import { ITableServerFilter } from './table-server-filter.inteface';
import { ITableServerResponseFilter } from './table-server-filter-response.interface';

export abstract class ITableService {
  abstract tableFilter(filter: ITableServerFilter): Promise<ITableServerResponseFilter | undefined>;
  abstract tableExportCSV(filter: ITableServerFilter): Promise<Blob | undefined>;
  abstract tableExportExcel(filter: ITableServerFilter): Promise<any | undefined>;
}
